import type { Schemas } from '#shopware'

const cmsAssociations = {
    associations: {
        media: {
            associations: {
                media: {},
            },
        },
        manufacturer: {},
        cmsPage: {
            associations: {
                sections: {
                    associations: {
                        blocks: {
                            associations: {
                                slots: {
                                    associations: {
                                        block: {
                                            associations: {
                                                slots: {
                                                    associations: {},
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
}

const productIncludes = {
    product: [
        'id',
        'name',
        'translated',
        'parentId',
        'productNumber',
        'markAsTopseller',
        'customFields',
        'calculatedPrice',
        'calculatedPrices',
        'calculatedCheapestPrice',
        'cover',
        'coverId',
        'manufacturer',
        'manufacturerId',
        'seoUrls',
    ],
    product_media: ['media', 'mediaId'],
    media: ['url', 'alt', 'title'],
    product_manufacturer: ['id', 'name', 'translated'],
    seo_url: ['seoPathInfo', 'pathInfo'],
}

export type UseCategorySearchReturn = {
    search(
        categoryId: string,
        options?: {
            withCmsAssociations?: boolean
            query?: Schemas['Criteria']
        },
    ): Promise<Schemas['Category']>

    advancedSearch(options: {
        withCmsAssociations?: boolean
        query: Schemas['Criteria']
    }): Promise<Schemas['Category'][]>
}

export function useCategorySearch(): UseCategorySearchReturn {
    const { apiClient } = useShopwareContext()

    async function search(
        categoryId: string,
        options?: {
            withCmsAssociations?: boolean
            query?: Schemas['Criteria']
        },
    ) {
        const associations = options?.withCmsAssociations ? cmsAssociations : {}
        const result = await apiClient.invoke(
            'readCategory post /category/{navigationId}',
            {
                pathParams: {
                    navigationId: categoryId,
                },
                headers: {
                    'sw-include-seo-urls': true,
                },
                body: {
                    associations,
                    ...options?.query,
                    includes: productIncludes,
                },
            },
        )
        return result.data
    }

    async function advancedSearch(options: {
        withCmsAssociations?: boolean
        query: Schemas['Criteria']
    }) {
        const associations = options?.withCmsAssociations
            ? cmsAssociations.associations
            : {}
        const result = await apiClient.invoke('readCategoryList post /category', {
            body: {
                associations,
                ...options?.query,
            },
        })
        return result.data.elements ?? []
    }

    return {
        search,
        advancedSearch,
    }
}
